import { createAsyncThunk } from "@reduxjs/toolkit";

import LocalStorage from "../../../../Services/Storage/LocalStorage";
import StorageModel from "../../../../Models/StorageModel";
import HttpsClient from "../../../../Services/HttpsClient";
import ApiHelper from "../../../../Services/ApiHelper";
import Cache from "../../../../Services/Cache";
import ApplicationResultsAPI, { ApplicationResultsApiUrls } from "../API/ApplicationResultsAPI";

const storage = new LocalStorage();
const storageModel = new StorageModel(storage);
const cache = new Cache(storageModel);

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const applicationResultsAPI = new ApplicationResultsAPI(apiHelper, cache);

export const getApplications = createAsyncThunk(
  ApplicationResultsApiUrls.getApplications,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    return await applicationResultsAPI.getApplications(payload, token);
  }
);

export const getApplicationResults = createAsyncThunk(
  ApplicationResultsApiUrls.getApplicationResults,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    const response = await applicationResultsAPI.getApplicationResults(payload, token);

    return response;
  }
);

/*
export const demoResults = createAsyncThunk(
  ApplicationResultsApiUrls.demoResults,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    const response = await applicationResultsAPI.deletePosition(payload, token);

    dispatch(getPositionsByCompanyId());

    return response;
  }
);
*/
